"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardPrimaryType = void 0;
var CardPrimaryType;
(function (CardPrimaryType) {
    CardPrimaryType["cardProduct"] = "card-product";
    CardPrimaryType["cardProductVertical"] = "card-product-vertical";
    CardPrimaryType["creditCard"] = "credit-card";
    CardPrimaryType["lightCard"] = "light-card";
    CardPrimaryType["newProductHomeCard"] = "new-product-home-card";
})(CardPrimaryType = exports.CardPrimaryType || (exports.CardPrimaryType = {}));
